import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import scriptLoader from 'react-async-script-loader';
import Loader from 'components/layout/Loader';
import GoogleMap from 'google-map-react';
import moment from 'moment';
import 'moment-timezone';

import { isPluginActive } from 'helpers/whiteLabel';
import * as constants from 'js/constants';

import FormInput from 'components/forms/FormInput';

import MapMarker from 'components/layout/MapMarker';

import ClientLocationImages from 'components/layout/client/ClientLocationImages';

class ClientLocationData extends React.Component {
  constructor(props) {
    super(props);

    moment.locale(globalLocale);

    this.state = {
      gmapLoading: false,
    };
  }

  updateGeo = (latLng, shownIndex) => {
    const { entity, changeEntity } = this.props;
    const coordinates = entity.createValue('coordinates', ['locations', shownIndex], latLng);
    const newEntity = entity.updateValue('coordinates', coordinates, ['locations', shownIndex]);
    changeEntity(newEntity);
  };

  changeEntity = (propertyName, value, callback = null) => {
    const { entity, changeEntity, shownIndex } = this.props;
    const newEntity = { ...entity.updateValue(propertyName, value, ['locations', shownIndex]) };
    changeEntity(newEntity, callback);

    if (
      propertyName === 'street' ||
      propertyName === 'houseNumber' ||
      propertyName === 'apartmentNumber' ||
      propertyName === 'zipCode' ||
      propertyName === 'city'
    ) {
      const locationData = entity.getLocations()[shownIndex];
      const fields = ['street', 'houseNumber', 'apartmentNumber', 'zipCode', 'city'];
      const address = fields
        .map(fieldName => {
          return propertyName !== fieldName ? locationData[fieldName] : value;
        })
        .join(' ');

      clearTimeout(this.geocodeTimeout);
      this.geocodeTimeout = setTimeout(() => {
        this.setState({ gmapLoading: true });
        geocodeByAddress(address)
          .then(results => getLatLng(results[0]))
          .then(latLng => {
            this.updateGeo(latLng, shownIndex);
            this.setState({ gmapLoading: false });
          })
          .catch(error => {
            console.error('Error', error);
            this.setState({ gmapLoading: false });
          });
      }, 300);
    }
  };

  updateEntity = (newEntity, callback = null) => {
    this.props.changeEntity(newEntity, callback);
  };

  getWeekdays = () => {
    const weekStartsWith = moment()
      .startOf('week')
      .date();
    let newDate = moment().date(weekStartsWith);
    let days = [];
    for (let i = 0; i < 7; i++) {
      days.push({
        name: moment(newDate).format('dddd'),
        isoWeekday: moment(newDate).isoWeekday(),
      });

      newDate = moment(newDate).add(1, 'days');
    }

    return days;
  };

  render() {
    const {
      intl,
      entityLoaded,
      entity,
      changeEntity,
      disabled,
      data,
      shownIndex,
      isScriptLoaded,
      projectConfig,
    } = this.props;
    const { messages } = intl;

    if (!isScriptLoaded) {
      return <Loader />;
    }

    const isRentSyncVamosoPluginActive = isPluginActive('RENT_SYNC_VAMOSO', projectConfig.data);
    const isGudatSolutionsDaPluginActive = isPluginActive('GUDAT_SOLUTIONS_DA', projectConfig.data);

    return (
      <div>
        <Row>
          <Col xs={12} md={6}>
            <div class="panel panel-transparent">
              <div class="panel-body">
                <p className="form-group-title">{messages.formGroup.basic_information}</p>
                <div class="form-group-attached m-b-15">
                  <FormInput
                    label={messages.internal_location_reference}
                    name="internal"
                    value={data.getInternal()}
                    meta={data.getInternalMetaInformation()}
                    validation={data.getInternalValidationResult()}
                    onChange={this.changeEntity}
                    disabled={disabled}
                  />
                  {isRentSyncVamosoPluginActive && (
                    <FormInput
                      label="Vamoso ID"
                      name="vamosoId"
                      value={data.getVamosoId()}
                      meta={data.getVamosoIdMetaInformation()}
                      validation={data.getVamosoIdValidationResult()}
                      onChange={this.changeEntity}
                      disabled={disabled}
                    />
                  )}

                  {isGudatSolutionsDaPluginActive && (
                    <>
                      <FormInput
                        label="Gudat Solutions DA - Group"
                        name="gudatSolutionsGroup"
                        value={data.getGudatSolutionsGroup()}
                        meta={data.getGudatSolutionsGroupMetaInformation()}
                        validation={data.getGudatSolutionsGroupValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label="Gudat Solutions DA - Center"
                        name="gudatSolutionsCenter"
                        value={data.getGudatSolutionsCenter()}
                        meta={data.getGudatSolutionsCenterMetaInformation()}
                        validation={data.getGudatSolutionsCenterValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                      />
                      <FormInput
                        label="Gudat Solutions DA - ID"
                        name="gudatSolutionsDaId"
                        value={data.getGudatSolutionsDaId()}
                        meta={data.getGudatSolutionsDaIdMetaInformation()}
                        validation={data.getGudatSolutionsDaIdValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                        infoText="ID des Standortes in booking.digitalesautohaus.de"
                      />
                    </>
                  )}
                </div>

                <div class="form-group-attached">
                  <FormInput
                    label={messages.name}
                    name="name"
                    value={data.getName()}
                    meta={data.getNameMetaInformation()}
                    validation={data.getNameValidationResult()}
                    onChange={this.changeEntity}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.street}
                    name="street"
                    value={data.getStreet()}
                    meta={data.getStreetMetaInformation()}
                    validation={data.getStreetValidationResult()}
                    onChange={this.changeEntity}
                    disabled={disabled}
                  />

                  <Row class="clearfix">
                    <Col sm={6}>
                      <FormInput
                        label={messages.house_number}
                        name="houseNumber"
                        value={data.getHouseNumber()}
                        meta={data.getHouseNumberMetaInformation()}
                        validation={data.getHouseNumberValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={6}>
                      <FormInput
                        label={messages.apartment_number}
                        name="apartmentNumber"
                        value={data.getApartmentNumber()}
                        meta={data.getApartmentNumberMetaInformation()}
                        validation={data.getApartmentNumberValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>

                  <Row class="clearfix">
                    <Col sm={6}>
                      <FormInput
                        label={messages.zip_code}
                        name="zipCode"
                        value={data.getZipCode()}
                        meta={data.getZipCodeMetaInformation()}
                        validation={data.getZipCodeValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                      />
                    </Col>
                    <Col sm={6}>
                      <FormInput
                        label={messages.city}
                        name="city"
                        value={data.getCity()}
                        meta={data.getCityMetaInformation()}
                        validation={data.getCityValidationResult()}
                        onChange={this.changeEntity}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </div>

                <p class="m-t-10 form-group-title">{messages.formGroup.contact_data}</p>
                <div class="form-group-attached">
                  <FormInput
                    type="email"
                    label={messages.email}
                    name="mainEmail"
                    value={data.getMainEmail()}
                    meta={data.getMainEmailMetaInformation()}
                    validation={data.getMainEmailValidationResult()}
                    onChange={this.changeEntity}
                    disabled={disabled}
                  />
                  <FormInput
                    label={messages.phone}
                    name="mainPhone"
                    value={data.getMainPhone()}
                    meta={data.getMainPhoneMetaInformation()}
                    validation={data.getMainPhoneValidationResult()}
                    onChange={this.changeEntity}
                    disabled={disabled}
                  />
                </div>
              </div>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <div class="panel panel-transparent">
              <div class="panel-body">
                <p>
                  {messages.formGroup.position_on_map}
                  {this.state.gmapLoading && <i class="m-l-10 fa fa-circle-notch fa-spin" />}
                </p>
                <div style={{ height: '400px' }} class="gmap">
                  <GoogleMap
                    ref="gmap"
                    bootstrapURLKeys={{
                      key: constants.GOOGLE_MAPS_KEY,
                      language: 'en',
                    }}
                    center={{ lat: data.getCoordinates().getLat(), lng: data.getCoordinates().getLng() }}
                    defaultZoom={16}
                    options={constants.mapOptions}
                    resetBoundsOnResize
                  >
                    <MapMarker lat={data.getCoordinates().getLat()} lng={data.getCoordinates().getLng()} />
                  </GoogleMap>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <ClientLocationImages
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={changeEntity}
              locationIndex={shownIndex}
              disabled={disabled}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default injectIntl(scriptLoader(constants.GOOGLE_MAPS_URL)(ClientLocationData));
